var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRampLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 352V32C384 14.25 369.75 0 352 0H32C14.25 0 0 14.25 0 32V352C0 369.75 14.25 384 32 384H38.875L3.25 467.375C-5.875 488.5 9.625 512 32.625 512H351.5C374.5 512 390 488.5 380.875 467.375L345.125 384H352C369.75 384 384 369.75 384 352ZM56.75 464L111.75 336H272.25L327.25 464H56.75ZM312.25 307.375C307.25 295.625 295.75 288 282.875 288H101.125C88.25 288 76.75 295.625 71.75 307.375L59.5 336H48V48H336V336H324.5L312.25 307.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRampLoading);
export default __webpack_public_path__ + "static/media/ramp-loading.32b28930df3eb9fe16462cd2a9ae95f3.svg";
export { ForwardRef as ReactComponent };